import React from 'react'

import './styles.css'

export const Modal = ({ children, onClose }) => {
  return (
    <div className='my-modal'>
      <div className='modal-content'>
        {children}
        <span className='return' onClick={onClose}>Aceptar</span>
      </div>
    </div>
  )
};
